// extracted by mini-css-extract-plugin
module.exports = {"errortext":"styles_errortext__1tXgI"};